var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('el-button',{attrs:{"type":_vm.btnType,"plain":"","icon":_vm.btnIcon},on:{"click":function($event){return _vm.handleCacheReload()}}},[_vm._v(_vm._s(_vm.btnLabel))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }